<div class="flex min-h-screen flex-col gap-6 p-6 pt-2">
  @if (apiError()) {
    <app-error [apiError]="apiError()" />
  }

  @if (errorLoadingProduct() && !isLoading()) {
    <app-error-data [title]="errorLoadingProduct()" />
  }

  @if (product() && !isLoading()) {
    <div class="flex items-start gap-8 rounded-[16px] p-6 pt-2">
      <app-image-carousel
        [profileImage]="productImageUrl()"
        [extraImages]="productImages()"
        [isLoading]="isLoading()" />

      <div class="flex h-full flex-1 flex-col justify-between gap-6 py-2">
        <div class="flex items-start justify-between">
          <div class="flex flex-col gap-2">
            <h1 class="text-title text-[28px] leading-tight font-[800]">
              {{ isArabic() ? product()?.titleAr || "غير متوفر" : product()?.titleEn || "Not Provided" }}
            </h1>

            <div class="flex items-center gap-3">
              @if (product()?.category?.titleAr || product()?.category?.titleEn) {
                <span
                  class="inline-flex items-center rounded-full bg-emerald-200 px-2.5 py-1 text-[12px] font-semibold text-emerald-700 ring-1 ring-emerald-600/20 ring-inset">
                  {{ isArabic() ? product()?.category?.titleAr : product()?.category?.titleEn }}
                </span>
              }
              @if (
                (product()?.category?.titleAr || product()?.category?.titleEn) &&
                (product()?.mfgCompany?.titleAr || product()?.mfgCompany?.titleEn)
              ) {
                <span class="text-[14px] text-gray-400">|</span>
              }
              @if (product()?.mfgCompany?.titleAr || product()?.mfgCompany?.titleEn) {
                <p class="text-[15px] font-[600] text-gray-600">
                  {{ isArabic() ? product()?.mfgCompany?.titleAr : product()?.mfgCompany?.titleEn }}
                </p>
              }
            </div>
          </div>

          <div class="relative">
            <button
              (click)="toggleDropdown($event)"
              class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full transition-all hover:bg-gray-100 focus:outline-none active:scale-95">
              <svg
                class="stroke-gray-dark"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="1"></circle>
                <circle cx="12" cy="5" r="1"></circle>
                <circle cx="12" cy="19" r="1"></circle>
              </svg>
            </button>

            @if (isDropdownOpen()) {
              <div
                [class]="isArabic() ? 'left-0' : 'right-0'"
                class="ring-opacity-5 absolute top-full z-50 mt-2 w-52 origin-top-right rounded-xl border border-gray-100 bg-white p-2 shadow-xl ring-1 ring-black focus:outline-none">
                <button
                  *hasScope="SCOPES.PRODUCTS.UPDATE"
                  (click)="handleAction('Edit Product')"
                  class="flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-left text-[14px] font-medium text-gray-700 transition-colors hover:bg-gray-50">
                  <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path
                      d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                  <span i18n="@@breadcrumbEditProduct">Edit Product</span>
                </button>
                <div class="my-1 border-t border-gray-100"></div>

                <button
                  (click)="handleAction(isActivated() ? 'Deactivate Product' : 'Activate Product')"
                  class="flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-left text-[14px] font-medium text-gray-700 transition-colors hover:bg-gray-50">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12S6.5 2 12 2m0 2c-1.9 0-3.6.6-4.9 1.7l11.2 11.2c1-1.4 1.7-3.1 1.7-4.9c0-4.4-3.6-8-8-8m4.9 14.3L5.7 7.1C4.6 8.4 4 10.1 4 12c0 4.4 3.6 8 8 8c1.9 0 3.6-.6 4.9-1.7" />
                  </svg>
                  @if (isActivated()) {
                    <span i18n="@@adminProductsActionDeactivate">Deactivate Product</span>
                  } @else {
                    <span i18n="@@adminProductsActionActivate">Activate Product</span>
                  }
                </button>
                <div
                  *hasScope="[SCOPES.PRODUCTS.UPDATE, SCOPES.PRODUCTS.DELETE]"
                  class="my-1 border-t border-gray-100"></div>
                <button
                  *hasScope="SCOPES.PRODUCTS.DELETE"
                  (click)="handleAction('Delete Product')"
                  class="flex w-full cursor-pointer items-center gap-3 rounded-lg px-3 py-2.5 text-left text-[14px] font-medium text-red-600 transition-colors hover:bg-red-50">
                  <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                  </svg>
                  <span i18n="@@adminProductsActionDelete">Delete Product</span>
                </button>
              </div>
            }
          </div>
        </div>

        <div class="flex h-full items-end">
          <span class="text-[13px] text-gray-400">Product ID: #{{ product()?.id }}</span>
        </div>
      </div>
    </div>
  } @else if (isLoading()) {
    <app-loading />
  }

  @if (!errorLoadingProduct() && !isLoading()) {
    <div class="border-b border-gray-200">
      <nav class="flex gap-4">
        <button
          *hasScope="SCOPES.PRODUCTS.READ_BY_ID"
          (click)="setActiveTab('details')"
          [ngClass]="
            activeTab() === 'details' ? 'borderTabsColor textTabsColor border-b-2' : 'border-transparent text-gray-500'
          "
          class="cursor-pointer pb-2 text-[14px] font-medium"
          i18n="@@productDetails">
          Product Details
        </button>

        @if (productType() === "has-sub") {
          <button
            *hasScope="SCOPES.PRODUCTS.READ_ATTRIBUTES"
            (click)="setActiveTab('attributes')"
            [ngClass]="
              activeTab() === 'attributes' ? 'borderTabsColor textTabsColor' : 'border-transparent text-gray-500'
            "
            class="cursor-pointer border-b-2 pb-2 text-[14px] font-medium"
            i18n="@@attributes">
            Attributes
          </button>

          <button
            *hasScope="SCOPES.SUB_PRODUCTS.READ_ALL"
            (click)="setActiveTab('sub-products')"
            [ngClass]="
              activeTab() === 'sub-products' ? 'borderTabsColor textTabsColor' : 'border-transparent text-gray-500'
            "
            class="cursor-pointer border-b-2 pb-2 text-[14px] font-medium"
            i18n="@@subProducts">
            Sub Products
          </button>
        }

        <button
          *hasScope="SCOPES.STOCK.READ_CURRENT_FOR_PRODUCT"
          (click)="setActiveTab('current-stock')"
          [ngClass]="
            activeTab() === 'current-stock'
              ? 'borderTabsColor textTabsColor border-b-2'
              : 'border-transparent text-gray-500'
          "
          class="cursor-pointer pb-2 text-[14px] font-medium"
          i18n="@@currentStock">
          Current Stock
        </button>

        <button
          *hasScope="SCOPES.STOCK.READ_STOCKS"
          (click)="setActiveTab('history-stock')"
          [ngClass]="
            activeTab() === 'history-stock'
              ? 'borderTabsColor textTabsColor border-b-2'
              : 'border-transparent text-gray-500'
          "
          class="cursor-pointer pb-2 text-[14px] font-medium"
          i18n="@@stock.stockHistory">
          Stock History
        </button>

        @if (productType() === "has-no-sub") {
          <button
            (click)="setActiveTab('configuration')"
            [ngClass]="
              activeTab() === 'configuration'
                ? 'borderTabsColor textTabsColor border-b-2'
                : 'border-transparent text-gray-500'
            "
            class="cursor-pointer pb-2 text-[14px] font-medium"
            i18n="@@configuration">
            Configuration
          </button>
        }
      </nav>
    </div>

    <div>
      @if (activeTab() === "details") {
        <app-product-info [product]="product()!" [productType]="productType()!" />
      } @else if (activeTab() === "attributes" && productType() === "has-sub") {
        <app-product-attributes-component *hasScope="SCOPES.PRODUCTS.READ_ATTRIBUTES" [productId]="product()!.id" />
      } @else if (activeTab() === "sub-products" && product()) {
        <app-product-sub-products *hasScope="SCOPES.SUB_PRODUCTS.READ_ALL" [productId]="product()!.id" />
      } @else if (activeTab() == "current-stock") {
        <app-product-current-stock
          *hasScope="SCOPES.STOCK.READ_CURRENT_FOR_PRODUCT"
          [productId]="product()!.id"
          [productType]="productType()!" />
      } @else if (activeTab() == "history-stock") {
        <app-product-history-stock
          *hasScope="SCOPES.STOCK.READ_STOCKS"
          [productId]="product()!.id"
          [productType]="productType()!" />
      } @else if (activeTab() === "configuration" && productType() === "has-no-sub") {
        <app-product-configuration [productId]="product()!.id" />
      }
    </div>
  }
</div>

@if (showSuccess()) {
  <app-successful-notification type="success" [title]="successMessage()" />
}

@if (showDeleteModal()) {
  <app-confirm-delete-modal
    [customTitle]="isArabic() ? 'تأكيد الحذف؟' : 'Confirm Delete?'"
    [customDescription]="
      isArabic() ? 'هل أنت متأكد من رغبتك في حذف هذا الصنف؟' : 'Are you sure you want to delete this product?'
    "
    (onConfirm)="confirmDeletion()"
    (onCancel)="showDeleteModal.set(false)"></app-confirm-delete-modal>
}

@if (confirmationActivationModal()) {
  <app-confirmation-dialog
    [productType]="productType()!"
    [type]="activationType()"
    [title]="confirmationModalContent().title"
    [description]="confirmationModalContent().description"
    [confirmContent]="confirmationModalContent().confirmContent"
    [cancelContent]="isArabic() ? 'إلغاء' : 'Cancel'"
    (onSubmit)="activationType() === 'activate' ? activateProduct() : deactivateProduct()"
    (onCancel)="confirmationActivationModal.set(false)"
    [error]="errorActivation()"></app-confirmation-dialog>
}
@if (notificationSuccess()) {
  <app-successful-notification
    type="success"
    [title]="
      isArabic()
        ? activationType() === 'activate'
          ? 'تم تفعيل الصنف بنجاح.'
          : 'تم إلغاء تفعيل الصنف بنجاح.'
        : activationType() === 'activate'
          ? 'Product activated successfully.'
          : 'Product deactivated successfully.'
    "
    i18n-title="@@admin.product.status.update.success" />
}
